import React from 'react';

const DrupalFieldItem = props => {
  //console.log('DFI', props);
  return (
    <div className="field-item-row">
      <label className="w-100">{props.label}</label>
      {props.link && (
        <span className="field-value font-bold"><a href={`mailto:${props.value}`}>{props.value}</a></span>
      )}
      {!props.link && (
        <span className="field-value font-bold">{props.value}</span>
      )}
    </div>
  );
};

export default DrupalFieldItem;
